export default __webpack_public_path__ + "static/media/docker.a6c7e1b8.svg";